import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en.js'
import zhLocale from './zh.js'
Vue.use(VueI18n)
const messages = {
  zh: {
    ...zhLocale,
  },
  en: {
    ...enLocale,
  },
}

const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || 'en',
  messages
})


export default i18n